<template>
<v-row>
    <v-overlay :opacity="0.5" :value="loading">
        <v-progress-circular indeterminate size="256">
            Por favor, aguarde ...
        </v-progress-circular>
    </v-overlay>
    <v-col cols="12">
        <v-row v-if="(files.length == 0 && status === 1) || this.requestID == 0">
            <v-col cols="12">
                <v-btn 
                    elevation="0"
                    rounded
                    color="primary"
                    x-large
                    @click="this.addFiles">
                    <v-icon left>mdi-file-image-plus-outline</v-icon>
                        Adicionar Arquivo
                </v-btn>
                <input id="select-files" type="file" accept="image/jpg, image/jpeg, application/pdf" @change="handleFilesUpload( $event )" multiple/>
            </v-col>
        </v-row>								
        <v-row v-if="files.length > 0">
            <v-col cols="12">
                <h4>Arquivo(s) Selecionado(s)</h4>
                <hr />            										
                <div 
                    v-for="(file, key) in files" 
                    v-bind:key="'file-'+key"
                    class="file-listing">{{ file.name }} <v-btn icon small class="remove-file" v-on:click="removeFile( key )"><v-icon title="Excluir">mdi-trash-can</v-icon></v-btn>
                </div>
            </v-col>
        </v-row>        
        <v-row v-if="files.length > 0 && this.requestID > 0">
            <v-col cols="12">
                <v-btn elevation="0" rounded  class="green white--text"  @click="this.submitFiles">
                    <v-icon left>mdi-file-upload-outline</v-icon> Enviar Arquivo
                </v-btn>
            </v-col>
        </v-row>
        <v-row v-if="arquivosEnviados.length > 0 && this.requestID > 0">
            <v-col cols="12">
                <hr />            									
            </v-col>
        </v-row>
        <v-row v-if="arquivosEnviados.length > 0 && this.requestID > 0">
            <v-col cols="12">
                <div 
                    v-for="(file, key) in arquivosEnviados" 
                    v-bind:key="'file-'+key"
                    class="">
                        <v-row>
                            <v-col cols="11">
                                {{key+1}} - {{ file.nome }}
                            </v-col>
                            <v-col cols="1">
                                <v-btn icon small class="download-file" v-on:click="downloadFile(key)">
                                    <v-icon title="Download">mdi-cloud-download</v-icon>
                                </v-btn>
                                <v-btn icon small class="remove-file" v-on:click="removeFileEnviados(key)" v-if="status === 1">
                                    <v-icon title="Excluir">mdi-trash-can</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                </div>           									
            </v-col>
        </v-row>
        <v-row v-if="arquivosEnviados.length == 0 && files.length == 0">
            <v-col cols="12">
                <v-chip
                    color="#CFD8DC" 
                >
                    Nenhum arquivo anexado.
                </v-chip>
            </v-col>
        </v-row>

        <v-dialog
            v-model="dialogFileInsert"
            width="500">
            <v-card>
                <v-card-title class="light-blue darken-4 white--text">
                    {{titleModalArquivo}}
                </v-card-title>
                <v-card-text>
                    <br/>
                    {{msgModalArquivo}}
                    <br/>
                </v-card-text>
                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                            <v-btn 
                                color="primary"
                                elevation="0"
                                large
                                outlined
                                rounded
                                @click="dialogFileInsert=false">
                                <v-icon left>mdi-check</v-icon>OK
                            </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="dialogError"
            width="500"
        >
            <v-card>
                <v-card-title class="light-blue darken-4 white--text">
                Atenção
                </v-card-title>

                <v-card-text>
                <br/>
                <p>{{returnedTitleMessage}}</p>
                <div class="text--primary espaco-top" v-html="returnedErrorMessage"></div>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    elevation="0"
                    large
                    outlined
                    rounded
                    @click="dialogError = false"
                >
                    <v-icon left>mdi-check</v-icon>
                    OK
                </v-btn>
                </v-card-actions>
            </v-card>    
        </v-dialog>  

    </v-col>
</v-row>
   
</template>

<script>
    import filesService from '../services/files.service';		
    export default {
        props:["dialog", "requestID", "status"],
        data(){
            return {
                files: [],
                arquivosEnviados: [],
                dialogFileInsert:false,
                dialogError: false,
                returnedTitleMessage:'Não foi possível efetuar a inclusão do(s) arquivo(s).',
                returnedErrorMessage:'',
                msgModalArquivo:'',
                titleModalArquivo:'',
                loading: false
            }
        },
        methods: {
            close() {
                this.$emit('update:dialog', false)
            },
            addFiles(){
                document.getElementById('select-files').click();
            },
            async submitFiles(){
                let objLogin = this.$store.state.login;
                let sucesso = false;
                this.loading = true;                
                for (var i = 0; i < this.files.length; i++) {
                    let file = this.files[i];
                    let dataFileUpload= {
                        solicitacaoID: this.requestID,
                        file: file,
                        ciUsuario: objLogin.userLogin                    
                    };  
                       

                    await filesService.submitFiles(dataFileUpload).then(
                        (result) => {                            
                            if (result.status == 'OK')
                            {
                                sucesso = true;
                                let arq = {
                                    "id": result.id,
                                    "nome": file.name
                                }                                
                                this.arquivosEnviados.push(arq);
                            }                                                                
                            else
                            {
                                sucesso = false;  
                                this.loading = false;
                                this.dialogError = true;
                                this.returnedErrorMessage = '<ul><li>' + result.errors.join('<li />') + '</ul>';
                                return;                          
                            }
                                
                        },
                        (error) => { 
                            this.loading = false;
                            this.dialogError = true;
                            this.returnedErrorMessage = '<ul><li>' + error.errors.join('<li />') + '</ul>';
                            sucesso = false;
                            return;
                    });			
                }	                
                this.loading = false;			                	
                if (sucesso)									
                {
                    this.titleModalArquivo = "Inclusão de Arquivo";
                    this.msgModalArquivo = "Inclusão realizada com sucesso.";
                    this.dialogFileInsert = true;                        
                }
                this.files = [];
            },
            
            handleFilesUpload( event ){
                let uploadedFiles = event.target.files;	                
                
                if (this.arquivosEnviados.length > 0)
                {
                    for (var i = 0; i < uploadedFiles.length; i++) {
                        if (this.arquivosEnviados.some(f => f.nome == uploadedFiles[i].name))
                        {
                            this.dialogError = true;
                            this.returnedErrorMessage = "O arquivo " + uploadedFiles[i].name + " já foi adicionado."
                            event.target.value = null;					
                            return;				
                        }

                        if (this.arquivosEnviados.some(f => f.nome == uploadedFiles[i].name))
                        {
                            this.dialogError = true;
                            this.returnedErrorMessage = "O arquivo " + uploadedFiles[i].name + " já foi adicionado."
                            event.target.value = null;					
                            return;				
                        }	
                        
                    }                    				
                    
                }
                for (var j = 0; j < uploadedFiles.length; j++) {
                    if (this.files.length >= 5 || uploadedFiles.length > 5)
                    {
                        this.dialogError = true;
                        this.returnedErrorMessage = "Quantidade de arquivos excedida. São permitidos até 5 arquivos por solicitação."
                        event.target.value = null;					
                        return;				
                    }
                    if (this.files.length > 0)
                    {
                        if (this.files.some(f => f.name == uploadedFiles[j].name))
                        {
                            this.dialogError = true;
                            this.returnedErrorMessage = "O arquivo " + uploadedFiles[j].name + " já foi adicionado."
                            event.target.value = null;					
                            return;				
                        }					
                    }

                    if (uploadedFiles[j].type != "application/pdf" && uploadedFiles[j].type != "image/jpeg")
                    {
                        this.dialogError = true;
                        this.returnedErrorMessage = "Tipo de arquivo inválido. Selecione apenas arquivos com extensão pdf ou jpg/jpeg."
                        event.target.value = null;					
                        return;	
                    }

                    if (uploadedFiles[j].size > 5241941) {
                        this.dialogError = true;
                        this.returnedErrorMessage = "O tamanho do arquivo " + uploadedFiles[j].name + " ultrapassa 5 MB."
                        event.target.value = null;					
                        return;	
                    }                    
                    this.files.push(uploadedFiles[j]);
                }
                
                
                event.target.value = null;
            },
            removeFile( key ){
                this.files.splice( key, 1 );
            },
            base64ToArrayBuffer(base64) {
                var binary_string = window.atob(base64);
                var len = binary_string.length;
                var bytes = new Uint8Array(len);
                for (var i = 0; i < len; i++) {
                    bytes[i] = binary_string.charCodeAt(i);
                }
                return bytes.buffer;
            },
            downloadFile(key) {
                let id = this.arquivosEnviados[key].id;
                filesService.downloadFile(id).then(
                    (response) => {			
                        var fileArray = this.base64ToArrayBuffer(response.conteudoArquivo)				
                        var fileURL = window.URL.createObjectURL(new Blob([fileArray]));
                        var fileLink = document.createElement('a');
                        fileLink.href = fileURL;
                        fileLink.setAttribute('download', response.nomeArquivo);
                        document.body.appendChild(fileLink);

                        fileLink.click();
                    },
                    (error) => { 
                        this.loading = false;
                        // var erros = "";
                        // for (var i = 0; i < error.errors.length; ++i) {
                        //     erros += "- " + error.errors[i] + "\n";
                        // }											
                        // alert(erros);
                        this.dialogError = true;
                        this.returnedErrorMessage = '<ul><li>' + error.errors.join('<li />') + '</ul>';
                    });	
                
            },
            removeFileEnviados(key){
                let msg = 'Deseja realmente excluir o arquivo ' + this.arquivosEnviados[key].nome + '?';
                this.$root.$confirm.open('Delete', msg)
                    .then((res) => {
                        if(res==true){
                            this.loading = true;				
                            let id = this.arquivosEnviados[key].id;
                            let objLogin = this.$store.state.login;
                            filesService.deleteFile(this.requestID, id, objLogin.userLogin).then(
                                () => {	
                                    this.loading = false;						
                                    this.arquivosEnviados.splice( key, 1 );
                                    this.titleModalArquivo = "Exclusão de Arquivo";
                                    this.msgModalArquivo = "Arquivo excluído com sucesso.";
                                    this.dialogFileInsert=true;
                                },
                                (error) => { 
                                    this.loading = false;
                                    //alert(error.Message);

                                    this.dialogError = true;
                                    this.returnedErrorMessage = error.Message;
                            });	
                        }
                    });
            },
            loadFiles() {
                let id = this.requestID;
                this.arquivosEnviados = [];
                this.loading = true;
                filesService.getFiles(id).then(
                    (result) => {	
                        this.loading = false;						
                        if (result.length > 0)
                        {
                            result.map((file) => {								
                                let arq = {
                                    "id": file.idArquivo,
                                    "nome": file.nomeArquivo
                                };
                                this.arquivosEnviados.push(arq);								
                            });													
                        }
                    },
                    (error) => { 
                        // var erros = "";
                        // for (var i = 0; i < error.errors.length; ++i) {
                        //     erros += "- " + error.errors[i] + "\n";
                        // }					
                        this.loading = false;
                        //alert(erros);
                        this.dialogError = true;
                        this.returnedErrorMessage = '<ul><li>' + error.errors.join('<li />') + '</ul>';
                    });			
            }
        }
    }
</script>

<style scoped>
    input[type="file"]{
        position: absolute;
        top: -2500px;		
    }
    .file-listing{
        width: 100%;
        margin: auto;
    }
    span.remove-file{
        color: red;
        cursor: pointer;
        width:100px;
        text-align: right;
    }
    span.download-file{
        color: green;
        cursor: pointer;
        width:100px;
        text-align: right;
    }
</style>